import { AUTHORITIES_MAP, UserConfigurationResource } from 'utils/AuthoritiesMap';

export interface IUserConfigurationData {
    allCurrencies: any[];
    currenciesByBrand: any[];
    timezoneList: any[];
    countries: any[];
    allGames: any[];
}

export const emptyUserConfiguration = (): IUserConfigurationData => ({
    allCurrencies: [],
    currenciesByBrand: [],
    timezoneList: [],
    countries: [],
    allGames: [],
});

export const getRequiredUserConfigurationResources = (
    authorities: string[] = [],
): UserConfigurationResource[] => {
    const authoritySet = new Set(authorities);
    const resources = new Set<UserConfigurationResource>();

    AUTHORITIES_MAP.forEach((authority) => {
        if (authoritySet.has(authority.name)) {
            authority.resources.forEach((resource) => resources.add(resource));
        }
    });

    return Array.from(resources);
};

export const createUserConfiguration = (
    entries: Array<[UserConfigurationResource, any[]]>,
): IUserConfigurationData =>
    entries.reduce((configuration, [resource, data]) => {
        configuration[resource] = data;
        return configuration;
    }, emptyUserConfiguration());
